<template>
  <v-card elevation="0">
    <v-card-text>
      <v-select
        label="Разделитель"
        :items="delimiters"
        v-model="delimiter"
        style="max-width: 20% !important"
        dense
        class="ml-8 mt-5"
      />
      <v-file-input
        label="Товары"
        dense
        style="max-width: 50% !important"
        show-size
        accept=".csv"
        @change="fileChanged"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn
        @click="parseF"
        :disabled="file == null || parsed"
        block
        color="primary"
      >
        Распарсить
      </v-btn>
      <v-spacer />
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data: () => ({
    delimiters: [
      { text: ".", value: "." },
      { text: ",", value: "," },
      { text: ";", value: ";" },
      { text: "Автовыбор", value: null },
    ],
    delimiter: null,
    file: null,
    parsed: false,
  }),
  methods: {
    ...mapActions(["parseFile"]),
    async parseF() {
      this.$emit("loading-start", "Парсинг файла");
      await this.parseFile({ file: this.file, delimiter: this.delimiter });
      if (this.fileData) {
        this.parsed = true;
        this.$emit("cant-continue", false);
      }
      this.$emit("loading-stop");
    },
    fileChanged(file) {
      this.parsed = false;
      this.file = file;
      this.$emit("cant-continue", !!this.file && !this.parsed);
    },
  },
  computed: {
    ...mapGetters(["fileData"]),
  },
  mounted() {
    this.$emit("cant-continue", true);
  },
};
</script>